import { postStockRule } from '../../services/api/stockRule.api';
import { POST_STOCK_RULE_REQUEST, POST_STOCK_RULE_SUCCESS, POST_STOCK_RULE_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[POST_STOCK_RULE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_STOCK_RULE_SUCCESS](state) {
			state.isLoading = false;
		},
		[POST_STOCK_RULE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async createStockRule({ commit }, params = {}) {
			try {
				commit(POST_STOCK_RULE_REQUEST);
				await postStockRule(params);
				commit(POST_STOCK_RULE_SUCCESS);
			} catch (error) {
				commit(POST_STOCK_RULE_FAILURE, error);
			}
		},
	},
};